import * as React from 'react';

import ReadersSidebar from './ReadersSidebar';

class ReadersHome extends React.Component {
  constructor(props) {
    super(props);
    // state
    this.state = {};
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    return (
      <div className='container-fluid' style={{ height: '100%' }}>
        <div className='row flex-nowrap' style={{ height: '100%' }}>
          <ReadersSidebar activePage='bp' />
          <div className='h-100 d-flex align-items-center'>
            <div
              className='p-2 col-example'
              style={{
                textAlign: 'center',
                marginLeft: '100px',
                marginRight: '100px',
                width: '60%',
              }}
            >

              <i className='fa-duotone fa-solid fa-book-reader fa-2xl mb-4' style={{'--fa-secondary-color': '#206896', '--fa-secondary-opacity': '0.6'}}  />
              <h2 style={{ fontWeight: 'bolder', fontStyle: 'italic' }}>
                Readers
              </h2>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ReadersHome;
